// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ybDlq","busy":"Header_busy__0faB1","time":"Header_time__znFKq","title":"Header_title__dMagM","buttons":"Header_buttons__dJ7TF"};